<template>
  <div>
    <NavBar
      :narBarTitle="$t('注册')"
      :msg="$t('欢迎注册NewWork智慧办公管理系统')"
      :showLogo="true"
      :companyCode="companyCode"
    />
    <van-form @submit="onReg" class="regForm">
      <div class="errSpace">
        <van-field
          v-model="mobile"
          clearable
          name="mobile"
          :placeholder="$t('请输入手机号')"
          :rules="[{ required: true, validator: mobileTest }]"
          @blur="verifyMobile"
        />
        <span v-show="mobileErr" class="error">{{ mobileErrMsg }}</span>
      </div>
      <div class="errSpace">
        <van-field
          v-model="code"
          center
          clearable
          name="code"
          :placeholder="$t('请输入验证码')"
          class="form-spacing"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              :disabled="!modelSms"
              @click="onSend"
              class="code-btn"
              :style="{ color: smsColor ? '#009BFF' : '#CCCCCC' }"
              >{{ smsTitle }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="errSpace">
        <van-field
          v-model="password"
          :type="seen ? 'password' : 'text'"
          center
          clearable
          name="password"
          :placeholder="$t('请输入密码')"
          autocomplete="“off”"
          :rules="[{ required: true, validator: pwdTest }]"
          @blur="verifyPwd"
        >
          <template #right-icon>
            <div @click="changeSeen" class="visible-btn">
              <img v-if="eye" src="@/assets/images/invisible.png" alt="" />
              <img v-else src="@/assets/images/visible.png" alt="" />
            </div>
          </template>
        </van-field>
      </div>
      <div v-if="pwdErr" class="errorMessage">
        <span v-show="pwdErr" class="error">{{
          $t('必须包含数字、⼤写字母、⼩写字母、特殊字符4种中⾄少3种，')
        }}</span>
        <span v-show="pwdErr" class="error">{{ $t('且不少于8位') }}</span>
      </div>
      <div class="errSpace">
        <van-field
          v-model="checkPassword"
          :type="seen ? 'password' : 'text'"
          class="form-spacing"
          center
          clearable
          name="checkPassword"
          :placeholder="$t('请再次输入密码')"
          autocomplete="“off”"
          :rules="[{ required: true, validator: checkTest }]"
          @blur="verifyCheckPwd"
        >
          <template #right-icon>
            <div @click="changeSeen" class="visible-btn">
              <img v-if="eye" src="@/assets/images/invisible.png" alt="" />
              <img v-else src="@/assets/images/visible.png" alt="" />
            </div>
          </template>
        </van-field>
        <span v-show="checkPwdErr" class="error">{{
          $t('两次密码不一致')
        }}</span>
      </div>
      <div class="errSpaceLast">
        <van-field
          v-model="username"
          clearable
          name="name"
          :placeholder="$t('请输入姓名')"
          :rules="[{ required: true, message: $t('请输入姓名') }]"
        />
      </div>
      <div @click="toLogin" class="to-reg">{{ $t('立即登录') }}</div>
      <div class="regBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :disabled="!allTest"
          class="reg-btn"
          :style="{ background: allTest ? '#009BFF' : '#DDDDDD' }"
          >{{ $t('立即注册') }}</van-button
        >
      </div>
      <van-checkbox v-model="checked" class="agreement" icon-size="16px">
        <span>{{ $t('我已阅读并同意') }}</span>
        <a href="https://pro.newbest.com.cn/privacy.html">{{
          $t('《用户协议及隐私政策》')
        }}</a>
      </van-checkbox>
    </van-form>
    <!-- <van-number-keyboard
      v-model="code"
      :show="showKeyboardCode"
      @blur="showKeyboardCode = false"
      safe-area-inset-bottom
    /> -->
  </div>
</template>
<script>
import Vue from 'vue'
import {
  getVerifyCode,
  register,
  verifyRegister,
  getCompanyInfo,
} from '@/services/api'
import NavBar from '@/components/navBar'
import {
  Form,
  Field,
  Button,
  Toast,
  Icon,
  Checkbox,
  NumberKeyboard,
} from 'vant'
import { verifyPassword } from '@/utils/utils'

Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(NumberKeyboard)

export default {
  name: 'Reg',
  components: {
    NavBar,
  },
  data() {
    return {
      mobile: '',
      password: '',
      checkPassword: '',
      code: '',
      smsTitle: this.$t('获取验证码'),
      checked: false,
      mobileErr: false,
      ifRegister: false,
      mobileErrMsg: this.$t('请输入正确的手机号'),
      showKeyboardCode: false,
      companyCode: '',
      username: null,
      pwdErr: false,
      checkPwdErr: false,
      seen: true,
      eye: true,
      openApproval: false,
    }
  },
  methods: {
    onSend() {
      let time = 60
      this.smsTitle = time + 's'
      const t = setInterval(() => {
        if (time === 1) {
          clearInterval(t)
          this.smsTitle = this.$t('重新获取')
        } else {
          time--
          this.smsTitle = time + 's'
        }
      }, 1000)
      getVerifyCode({
        mobile: this.mobile,
        plate: 'NEW_WORK',
        time: 600,
      })
    },
    async onReg(v) {
      try {
        await register({
          companyCode: this.companyCode,
          registerSource: 'H5',
          ...v,
        })
        if (this.openApproval) {
          Toast.success(this.$t('注册成功，请等待管理员审核！！！'))
          this.$router.push(`/login?companyCode=${this.companyCode}`)
        } else {
          Toast.success(this.$t('注册成功'))
          this.$router.push(`/login?companyCode=${this.companyCode}`)
        }
        // this.$router.push('setPwd?mobile=' + this.mobile)
      } catch (error) {
        Toast.fail(error.response.data.message)
      }
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.mobile)
    },
    pwdTest() {
      return verifyPassword(this.password)
    },
    checkTest() {
      return this.password === this.checkPassword
    },
    changeSeen() {
      this.seen = !this.seen
      this.eye = !this.eye
    },
    codeTest() {
      return this.code.length > 0
    },
    async verifyMobile() {
      if (this.mobileTest()) {
        try {
          await verifyRegister({
            mobile: this.mobile,
            companyCode: this.companyCode,
          })
          this.mobileErrMsg = this.$t('请输入正确的手机号')
          this.mobileErr = false
          this.ifRegister = false
        } catch (error) {
          this.mobileErrMsg = error.response.data.message
          this.ifRegister = true
          this.mobileErr = true
        }
      } else {
        this.mobileErr = true
      }
    },
    verifyPwd() {
      if (this.pwdTest()) {
        this.pwdErr = false
      } else {
        this.pwdErr = true
      }
    },
    verifyCheckPwd() {
      if (this.checkTest()) {
        this.checkPwdErr = false
      } else {
        this.checkPwdErr = true
      }
    },
    toLogin() {
      this.$router.replace(`/login?companyCode=${this.companyCode}`)
    },
    queryCompanyInfo(companyCode) {
      getCompanyInfo(companyCode).then((res) => {
        this.openApproval =
          res.openApproval != undefined && res.openApproval == false
            ? false
            : true
      })
    },
  },
  computed: {
    allTest() {
      return (
        this.mobileTest() === true &&
        this.codeTest() === true &&
        this.pwdErr === false &&
        this.checkPwdErr === false &&
        this.checked === true &&
        this.ifRegister === false
      )
    },
    modelSms() {
      return (
        this.mobileTest() === true &&
        (this.smsTitle == this.$t('获取验证码') ||
          this.smsTitle == this.$t('重新获取')) &&
        this.ifRegister === false
      )
    },
    smsColor() {
      return this.mobileTest() === true
    },
  },
  created() {
    this.companyCode =
      this.$route.query.companyCode ||
      JSON.parse(localStorage.getItem('companyCode')).code
    this.queryCompanyInfo(
      this.$route.query.companyCode ||
        JSON.parse(localStorage.getItem('companyCode')).code
    )
  },
}
</script>
<style lang="less" scoped>
.regForm {
  margin: 32px 8px 0px;

  .code-btn {
    background: none;
    border: none;
    font-size: 14px;
  }

  .reg-btn {
    border: none;
    font-size: 16px;
  }

  .to-reg {
    width: 100px;
    padding-left: 16px;
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 32px;
    display: block;
  }

  .regBox {
    width: 280px;
    height: 44px;
    margin: 0 40px;
  }

  /deep/.form-spacing {
    margin-top: 12px;

    .van-cell__value {
      border-bottom: 1px solid #ececec;
    }
  }

  .agreement {
    margin-top: 5px;
    padding: 0px 45px;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
  }
}

.errorMessage {
  height: 48px;
}

.error {
  height: 24px;
  font-size: 12px;
  color: #e02020;
  line-height: 24px;
  padding-left: 16px;
}

.errSpace {
  height: 67px;
  padding-bottom: 24px;
}

.errSpacePass {
  height: 67px;
  padding-bottom: 24px;
  margin-top: 30px;
}

.errSpaceLast {
  height: 67px;
  padding-bottom: 24px;
  margin-top: 10px;
}
</style>
